import React, { useState, useEffect } from 'react';
import { withTranslation } from "react-i18next";
import { Card } from 'primereact/card';
import { TabView, TabPanel } from 'primereact/tabview';
import { getLabel, getLang } from '../../helpers/translator';
import LineBarChart from './common/LineBarChart';
import AggregateParticleSizeChart from './custom-charts/AggregateParticleSizeChart';
import Filter from './common/Filter';
import Table from './common/Table';
import Entry from './common/Entry';
import { logEvent } from '../../helpers/amplitude';


const AggregateParticleSizeDistribution = ({ history, test, toast }) => {
  const testCode = 'aggregate-particle-size-distribution';
  const { title, fields } = test?.definition || {};
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const pollutionAndThinnessKeys = [{ val: 'thinnessModule', type: 'line' }, { val: 'pollution', type: 'bar' }];
  const pollutionAndThinnessTitle = getLabel('physicalTest.generalLabels.pollutionAndFineness');
  const grainSizeDistributionTitle = getLabel('physicalTest.generalLabels.grainSizeDistribution');
  const grainSizeDistributionKeys = ['0_125_calc', '0_25_calc', '0_5_calc', '1_calc', '2_calc', '4_calc', '5_6_calc', '8_calc', '11_2_calc', '16_calc', '22_4_calc', '31_5_calc'];

  useEffect(() => {
    logEvent('[Aggregate Particle Size Distribution] View');
  });

  return (
    <div>
      <Card title={title ? title[getLang()] : ''}>
        <TabView>
          <TabPanel header={title ? title[getLang()] : ''}>
            <Filter fields={fields ? fields.filter(f => f.filter) : []} loading={loading} setLoading={setLoading} setData={setData} toast={toast} testCode={testCode} />
            <Table testCode={testCode} fields={fields} loading={loading} data={data} toast={toast} setData={setData} setLoading={setLoading} />
            <LineBarChart fields={fields} loading={loading} data={data} title={pollutionAndThinnessTitle} keys={pollutionAndThinnessKeys} />
            <AggregateParticleSizeChart fields={fields} loading={loading} data={data} title={grainSizeDistributionTitle} keys={grainSizeDistributionKeys} />
          </TabPanel>
          <TabPanel header={getLabel('physicalTest.generalLabels.newTestHeader')}>
            <Entry fields={fields} loading={loading} setLoading={setLoading} testCode={testCode} toast={toast} />
          </TabPanel>
          <TabPanel header={getLabel('physicalTest.generalLabels.updateTestHeader')}>
            <Filter fields={fields ? fields.filter(f => f.filter) : []} loading={loading} setLoading={setLoading} setData={setData} toast={toast} testCode={testCode} />
            <Table testCode={testCode} fields={fields} loading={loading} data={data} toast={toast} setData={setData} setLoading={setLoading} editMode />
          </TabPanel>
        </TabView>
      </Card>
    </div>
  )
};

export default withTranslation()(AggregateParticleSizeDistribution);